module.exports = "data:image/webp;base64,UklGRj4AAABXRUJQVlA4TDIAAAAvJ4AGACATsAikrTLCCONbAgdBAEn5mwyzyggTZhthzWDSex3Z9X8CrEbcbD/OUuF/AA=="